<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route(to, from) {
      let accountInfo = sessionStorage.getItem("accountInfo");
      if (!accountInfo || accountInfo == null) {
        if (to.path == "/not_found_page" || to.path == "/h5_face_collection") {
        } else {
          this.$message.error("登录身份已失效，请重新登录！");
          this.$router.push({ name: "Login" });
        }
      }
    }
  },
  created() {
    document.title = process.env.TITLE;
    let accountInfo = sessionStorage.getItem("accountInfo");
    if (!accountInfo || accountInfo == null) {
      let hash = "";
      if (location.hash.indexOf("?") != -1) {
        hash = location.hash.split("?")[0];
      } else {
        hash = location.hash;
      }
      if (
        hash == "#/not_found_page" ||
        hash == "#/h5_face_collection"
      ) {
      } else {
        this.$message.error("登录身份已失效，请重新登录！");
        this.$router.push({ name: "Login" });
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Rajdhani-Medium", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #fff;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue